import { render, staticRenderFns } from "./newlist.vue?vue&type=template&id=f290329a&scoped=true"
import script from "./newlist.vue?vue&type=script&lang=js"
export * from "./newlist.vue?vue&type=script&lang=js"
import style0 from "./newlist.vue?vue&type=style&index=0&id=f290329a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f290329a",
  null
  
)

export default component.exports